import type { ReactNode } from 'react';

// Cartel a nivel formulario, para lo que no es de un campo puntual
// ("ese horario ya está ocupado").
export function AvisoError({ tono = 'error', children }: {
  tono?: 'error' | 'aviso' | 'exito';
  children?: ReactNode;
}) {
  if (!children) return null;
  return <div role="alert" className={`aviso-formulario aviso-formulario--${tono}`}>{children}</div>;
}
